var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "QuestionSerp",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.997 5.386C4.997 4.022 5.97 3 7.5 3c1.529 0 2.504 1.022 2.504 2.386 0 .58-.154.941-.358 1.222-.229.315-.55.573-.997.907l-.115.086c-.831.618-2.04 1.516-2.04 3.399a1 1 0 101.996 0c0-.85.429-1.19 1.354-1.883.43-.322.988-.741 1.417-1.333.454-.626.739-1.4.739-2.398C12 2.871 10.084 1 7.5 1S3 2.87 3 5.386a1 1 0 101.997 0zM7.5 15a1 1 0 100-2 1 1 0 000 2z"
  })));
}
export default SvgFaqIcon;